/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { ClipboardCheck } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j05-s05-decidir-manutencao';
export function DecidirManutencaoRecursosPage() {
  const [s, setS] = useState<any>();
  async function call(path: string, body?: any) {
    const r = await chamarApi<any>(NS + path, {
      metodo: path === '/state' ? 'GET' : 'POST',
      corpo: body,
    });
    setS(r.state);
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando decisões…
      </main>
    );
  return (
    <main className="min-w-0 space-y-5">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      <section className="space-y-3">
        {s.solicitacoes.map((m: any) => (
          <article key={m.id} className="rounded-md border p-4">
            <h2 className="font-semibold">
              <ClipboardCheck className="mr-2 inline h-5 w-5" />
              {m.tipo} · {m.status}
            </h2>
            <p>{m.motivo}</p>
            <p>Impacto: {m.impactoOs.ativas} OS ativa(s)</p>
            {m.status === 'SUBMETIDA' && (
              <div className="mt-3 flex gap-2">
                <Button
                  onClick={() =>
                    void call('/verbs/decidir', { manutencaoId: m.id, decisao: 'APROVADA' })
                  }
                >
                  Aprovar
                </Button>
                <Button
                  variant="outline"
                  onClick={() =>
                    void call('/verbs/decidir', { manutencaoId: m.id, decisao: 'REJEITADA' })
                  }
                >
                  Rejeitar
                </Button>
              </div>
            )}
          </article>
        ))}
      </section>
    </main>
  );
}
